export const configEditorConfigChangedSelector = state => state.configEditorConfigChanged;
export const setConfigEditorConfigChangedSelector = state => state.setConfigEditorConfigChanged;
export const editedConfigContentSelector = state => state.editedConfigContent;
export const setEditedConfigContentSelector = state => state.setEditedConfigContent;
export const originalConfigSelector = state => state.originalConfig;
export const setOriginalConfigSelector = state => state.setOriginalConfig;
export const resetConfigEditorSelector = state => state.resetConfigEditor;
export const saveConfigEditorSelector = state => state.saveConfigEditor;
export const configEditorSaveErrorSelector = state => state.configEditorSaveError;
export const setConfigEditorSaveErrorSelector = state => state.setConfigEditorSaveError;
